module.exports = __webpack_public_path__ + "799f3f79fb6429e5c9dad5568ddad8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_variable_x1_variable/public/picture/beach.jpg
// module id = 428
// module chunks = 0